import React, { useEffect, useState } from "react";
import {
  Badge,
  ListGroup,
  Modal,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { getPaymentType } from "../../_redux/billingCrud";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

export default function InvoiceTypeModal({ show, onHide, createPayment }) {
  const [invoiceType, setInvoiceType] = useState([]);

  useEffect(() => {
    if (show) {
      getPaymentType()
        .then((res) => {
          const { data: invoice_type } = res;
          const filterInvoice = invoice_type.data.filter(
            (item) => item.is_active == true
          );
          setInvoiceType(filterInvoice);
        })
        .catch((err) => console.log(err));
    }
  }, [show]);

  return (
    <>
      <Modal show={show} onHide={onHide} size="lg">
        <Modal.Header>
          <h4>Pilih Tipe Pembayaran</h4>
        </Modal.Header>
        <Modal.Body>
          <ListGroup as="ol" numbered>
            {invoiceType.map((item) => (
              <>
                <ListGroup.Item
                  as="li"
                  className="d-flex justify-content-between align-items-start"
                >
                  <div className="ms-2 me-auto">
                    <div className="fw-bold">{item.name}</div>
                    {item.type}
                  </div>
                  <OverlayTrigger
                    overlay={<Tooltip id="invoice-type-tooltip">Pilih</Tooltip>}
                  >
                    <a
                      className="btn btn-icon btn-light btn-hover-success btn-sm"
                      onClick={() => {
                        createPayment(item);
                      }}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-success">
                        <CheckCircleIcon />
                      </span>
                    </a>
                  </OverlayTrigger>
                </ListGroup.Item>
              </>
            ))}
          </ListGroup>
        </Modal.Body>
      </Modal>
    </>
  );
}
